import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=55f5a47e&"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f5a47e')) {
      api.createRecord('55f5a47e', component.options)
    } else {
      api.reload('55f5a47e', component.options)
    }
    module.hot.accept("./HeaderComponent.vue?vue&type=template&id=55f5a47e&", function () {
      api.rerender('55f5a47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header/HeaderComponent.vue"
export default component.exports